if (!customElements.get('product-custom-variation')) {
  customElements.define('product-custom-variation', class ProductCustomVariation extends HTMLElement {
    constructor() {
      super();
    }

    handleChange(e) {
      window.location.href = e.currentTarget.value;
    }
  });
}